var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentMdl2Photo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3V21H0V3H24ZM1.5 4.5V12.4336L6.75 7.19531L14.25 14.6953L17.25 11.6953L22.5 16.9336V4.5H1.5ZM1.5 19.5H16.9336L6.75 9.30469L1.5 14.5664V19.5ZM22.5 19.5V19.0664L17.25 13.8047L15.3047 15.75L19.0664 19.5H22.5ZM18.75 9C18.5469 9 18.3711 8.92578 18.2227 8.77734C18.0742 8.62891 18 8.45312 18 8.25C18 8.04688 18.0742 7.87109 18.2227 7.72266C18.3711 7.57422 18.5469 7.5 18.75 7.5C18.9531 7.5 19.1289 7.57422 19.2773 7.72266C19.4258 7.87109 19.5 8.04688 19.5 8.25C19.5 8.45312 19.4258 8.62891 19.2773 8.77734C19.1289 8.92578 18.9531 9 18.75 9Z",
    fill: "#1373E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentMdl2Photo2);
export default __webpack_public_path__ + "static/media/fluent-mdl2_photo-2.00bcc794510be8badda4eb80aca82dfa.svg";
export { ForwardRef as ReactComponent };